import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Main, Voltar } from '../styles/GlobalStyled.js'

export default function Home() {
  const [tamAnel, setTamAnel] = useState(5.5) // Valor inicial ajustado

  const [aro, setAro] = useState(10)

  useEffect(() => {
    if (tamAnel <= 4.396) {
      // Circunferência calculada para diâmetro 1.399
      setAro('Seu aro é: ##')
    } else if (tamAnel <= 4.712) {
      // Circunferência calculada para diâmetro 1.5
      setAro('Seu aro é: 10/11')
    } else if (tamAnel <= 5.179) {
      // Circunferência calculada para diâmetro 1.65
      setAro('Seu aro é: 14')
    } else if (tamAnel <= 5.34) {
      // Circunferência calculada para diâmetro 1.7
      setAro('Seu aro é: 16')
    } else if (tamAnel <= 5.5) {
      // Circunferência calculada para diâmetro 1.75
      setAro('Seu aro é: 18')
    } else if (tamAnel <= 5.654) {
      // Circunferência calculada para diâmetro 1.8
      setAro('Seu aro é: 19/20')
    } else if (tamAnel <= 5.969) {
      // Circunferência calculada para diâmetro 1.9
      setAro('Seu aro é: 22/24')
    } else if (tamAnel <= 6.283) {
      // Circunferência calculada para diâmetro 2.0
      setAro('Seu aro é: 25/26')
    } else if (tamAnel <= 6.597) {
      // Circunferência calculada para diâmetro 2.1
      setAro('Seu aro é: 27/28')
    } else if (tamAnel <= 6.911) {
      // Circunferência calculada para diâmetro 2.2
      setAro('Seu aro é: 29/30')
    } else if (tamAnel <= 7.225) {
      // Circunferência calculada para diâmetro 2.3
      setAro('Seu aro é: 31/32')
    } else {
      setAro('Seu aro é: ##') // Caso não se encaixe em nenhuma medida
    }
  }, [tamAnel])

  return (
    <Main>
      <Container>
        <Instrucoes>
          <h2>Agora é fácil!</h2>
          <h3>
            Você só precisa arrastar a bolinha laranja até que indique a
            distância que você acabou de medir no passo anterior.
          </h3>
        </Instrucoes>

        <h3>{tamAnel} cm</h3>
        <input
          type="range"
          name="tamanho"
          min="4.4"
          max="7.2"
          step="0.05" // Ajuste o step para 0.1
          value={tamAnel}
          onChange={(e) =>
            setTamAnel(parseFloat(parseFloat(e.target.value).toFixed(2)))
          } // Arredonda para uma casa decimal
        />
        <h1>{aro}</h1>

        <Footer>
          <a
            href="https://www.comcompromisso.com.br"
            target="_blank"
            rel="noreferrer"
          >
            <button>Ir para a loja on-line</button>
          </a>
          <Link to={'/instrucao-sem-anel'}>
            <Voltar>Voltar</Voltar>
          </Link>
        </Footer>
      </Container>
    </Main>
  )
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vw;
  height: 800px;

  position: relative;
  color: #414141;

  @media (min-width: 1300px) {
    height: 90vh;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2,
  h1 {
    font-weight: bold;
    line-height: 50px;
    font-size: 30px;
    font-family: 'conso' !important;

    @media (min-width: 1300px) {
      font-size: 4vw;
      line-height: 150px;
    }
  }

  h1 {
    font-family: 'conso' !important;
    font-weight: normal;

    @media (min-width: 1300px) {
      font-size: 3vw;
      line-height: 15vh;
    }
  }
  h3 {
    line-height: 26px;
    font-size: 16px;
    font-size: 16px;

    @media (min-width: 1300px) {
      font-size: 2vw;
      line-height: 6vh;
    }
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 5px;
    background: rgba(102, 176, 180, 0.3);
    outline: none;
    width: 80vw;
    height: 10px;
    margin: 10px 20px;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #642c1c;
    cursor: pointer;
  }

  input::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #e1d2c7;
    cursor: pointer;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90vw;
  padding: 0 3%;
  text-align: center;
  position: absolute;
  bottom: 10px;

  @media (min-width: 1300px) {
    padding: 0 10%;
  }

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 20px;
    background-color: #66b0b4;
    background-size: cover;
    color: white;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 99px;
    border: 1px solid #d9bf9c;
    cursor: pointer;
  }
`

const Instrucoes = styled.div`
  width: 80vw;
  text-align: left;
  margin: 3vh 0 50px 0;
`
